module.exports = __webpack_public_path__ + "4414f7bcd75d90ff17555382bd5b4747.pdf";